export enum GA_PAGE_NAMES {
  ITEM_VIEW = 'item',
  LIST_OUTLINE_VIEW = 'listOutlineView',
  SECTION_VIEW = 'section',
}
